import state from './moduleEnterpriseDocumentManagerState.js'
import mutations from './moduleEnterpriseDocumentManagerMutations.js'
import actions from './moduleEnterpriseDocumentManagerActions.js'
import getters from './moduleEnterpriseDocumentManagerGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
